import { Component } from 'react'
import styled from '@emotion/styled'
import { Box, Icons, Text } from 'stylewhere/components'
import { Emulation } from 'core/shared'
import { intervalToDuration, differenceInDays } from 'date-fns'

interface Props {
  emulation: Emulation
  index: number
  onSubmit: (value: string, confirm?: boolean) => void
  onFavorite: (name: string, key: number) => void
  onDelete: (name: string, key: number) => void
  last: boolean
}

export class EmulationHistory extends Component<Props> {
  getDate = () => {
    const { emulation } = this.props

    // Controllo se emulation.date esiste e è valido
    if (!emulation.date) {
      return 'Data non disponibile'
    }

    let str = ''
    const now = new Date()
    const date = new Date(emulation.date)

    // Controllo se la data è valida
    if (isNaN(date.getTime())) {
      return 'Data non valida'
    }

    const { hours, minutes, seconds } = intervalToDuration({ start: date, end: now })
    const days = differenceInDays(date, now)
    if (days > 30) str = date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear()
    else if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) str = 'now'
    else {
      if (days > 0) str = days + 'd'
      else if (hours > 0) str += hours + 'h'
      else if (minutes > 0) str += minutes + 'm'
      else if (seconds > 0) str += seconds + 's'
    }
    return str
  }
  render() {
    const { emulation, onSubmit, onFavorite, onDelete, last } = this.props
    return (
      <EmulationBox row flex={0} center mb={last ? 2 : 2} p={'5px 5px'} borderRadius={8}>
        <Text onClick={() => onSubmit(emulation.value, false)} style={{ flex: 1, marginRight: 10, cursor: 'pointer' }}>
          {emulation.favorite ? emulation.label : emulation.name}
          <EmulationDate>{this.getDate()}</EmulationDate>
        </Text>
        <div
          style={{ marginRight: 5, cursor: 'pointer' }}
          onClick={() => {
            onFavorite(emulation.name, emulation.key)
          }}
        >
          {emulation.favorite ? (
            <Icons.FavoriteActive width={16} height={16} />
          ) : (
            <Icons.Favorite width={16} height={16} />
          )}
        </div>
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            onDelete(emulation.name, emulation.key)
          }}
        >
          <Icons.DeleteBlack width={16} height={16} />
        </div>
      </EmulationBox>
    )
  }
}

const EmulationBox = styled(Box)`
  :hover {
    background-color: #dcdcdc;
  }
`

const EmulationDate = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 0.52);
  margin-left: 7px;
`
